import { ModalProps } from "@cividao/components"
import { DomainError } from "../../../domain/_kernel/DomainError"
import { ReactNode } from "react"

export enum ErrorModalStateType {
  Idle = "idle",
  SendingReport = "sendingReport",
  ReportSent = "reportSent",
}

export type ErrorModalState =
  | { type: ErrorModalStateType.Idle }
  | { type: ErrorModalStateType.SendingReport }
  | { type: ErrorModalStateType.ReportSent; reportId: string; copied: boolean }

export interface ErrorModalProps extends Omit<ModalProps, "title" | "children"> {
  error: DomainError
  autoHideCopyMessage?: boolean
  copyMessageDuration?: number
  children?: ReactNode
}
